import apis from "../../../api";
import { getMyProfileAction } from "../actionCreators/commonActionCreator";
import loaders from "../actionCreators/loadersActionCreator";

// export const getHeaderUserProfileActionHandler = () => async (dispatch) => {
//   await apis.profile
//     .getHeaderUserProfile()
//     .then((response) => {
//       if (response.status === 200 && response.data) {
//         localStorage.setItem("firstName", response?.data?.FirstName);
//         dispatch(getMyProfileAction(response.data));
//       }
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const getUserGroupByUserIdActionHandler =
  (userID, setState, setLoader) => async (dispatch) => {
    // dispatch(loaders.header.profileLoader(true))
    setLoader(true);
    await apis.profile
      .getUserGroupByUserId(userID)
      .then((response) => {
        setState(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });
    // .finally(() => {
    //   dispatch(loaders.header.profileLoader(false));
    // });
  };

export const putMyProfileActionHandler =
  (data, payloadData, setLoader) => async (dispatch) => {
    setLoader(true);
    return await apis.profile
      .putMyProfile(data, payloadData)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
